// import { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Building2, Rocket, Briefcase, Building, ArrowRight, ArrowLeft, Check, X,
//   Loader2, Mail, Globe2, User, AlertCircle, CheckCircle2,
//   Users, Layers, Briefcase as BriefcaseIcon, Lock, Eye, EyeOff, Network,
// } from "lucide-react";
// import logo from "../assets/Provinyx-logo.png";

// // ── Backend API base URL — point this at your Node.js server ──────────────────
// const API_BASE = "https://api.provinyx.com"; // ← local testing; switch back to your deployed URL later
// // ─────────────────────────────────────────────────────────────────────────────

// const COMPANY_TYPES = [
//   { id: "small",   label: "Small Business", desc: "1 – 10 employees",        icon: Building2 },
//   { id: "startup", label: "Startup",        desc: "Early-stage, high growth", icon: Rocket    },
//   { id: "medium",  label: "Medium Business",desc: "11 – 200 employees",       icon: Briefcase },
//   { id: "large",   label: "Large Enterprise",desc: "200+ employees",          icon: Building  },
// ];

// const COMPANY_MODES = [
//   { id: "single",   label: "Single Company",   desc: "One brand, one workspace",        icon: Building2 },
//   { id: "multiple", label: "Multiple Companies", desc: "Manage several brands together", icon: Layers    },
// ];

// // Exact 7 options required by the tech lead's multi-mode provisioning
// // service (schemaProvisionServiceMulti.js TEMPLATE_MAP) — no "Other"
// // option, since each one maps to a specific template schema on the
// // backend and an unmapped value would throw "Unsupported company type".
// const SUPPLY_CHAIN_ROLES = [
//   "Manufacturer",
//   "Distributor",
//   "Retailer",
//   "Recycler",
//   "Regulator",
//   "Customer",
//   "Repair/Refurb",
// ];

// const USER_ROLES = [
//   "Owner / Founder",
//   "Admin",
//   "Operations Manager",
//   "Compliance Officer",
//   "IT / Technical Lead",
//   "Other",
// ];

// const COUNTRIES = [
//   "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina",
//   "Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados",
//   "Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana",
//   "Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon",
//   "Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros",
//   "Congo (Republic of)","Congo (DRC)","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic",
//   "Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador",
//   "Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Fiji","Finland","France",
//   "Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea",
//   "Guinea-Bissau","Guyana","Haiti","Honduras","Hungary","Iceland","India","Indonesia","Iran",
//   "Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati",
//   "Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein",
//   "Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta",
//   "Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco",
//   "Mongolia","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal",
//   "Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia",
//   "Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru",
//   "Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda",
//   "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino",
//   "Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone",
//   "Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea",
//   "South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria",
//   "Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga",
//   "Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine",
//   "United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu",
//   "Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe",
// ];

// const STEPS = [
//   { id: 1, label: "Company Type" },
//   { id: 2, label: "Business Details" },
//   { id: 3, label: "Personal Details" },
// ];

// /* ══════════════════════════════════════════
//    Left panel — blue intro (Step 1)
// ══════════════════════════════════════════ */
// function BluePanel() {
//   return (
//     <div className="hidden lg:flex flex-col justify-between w-[380px] flex-shrink-0 px-10 py-12 text-white relative overflow-hidden"
//       style={{ background: "linear-gradient(160deg,#2563eb 0%,#1e40af 100%)" }}>

//       <div className="absolute top-0 right-0 w-72 h-72 bg-white/5 rounded-full translate-x-1/3 -translate-y-1/3 pointer-events-none" />
//       <div className="absolute bottom-0 left-0 w-72 h-72 bg-white/5 rounded-full -translate-x-1/3 translate-y-1/3 pointer-events-none" />

//       <div className="relative">
//         <button
//           onClick={() => { window.location.href = "/"; }}
//           className="flex items-center gap-2 mb-16 focus:outline-none"
//         >
//           <img src={logo} alt="Provinyx" className="h-7 w-auto object-contain" style={{ filter: "brightness(0) invert(1)" }} />
//         </button>

//         <h2 className="text-3xl font-bold leading-tight mb-4">
//           A few clicks away from onboarding your company.
//         </h2>
//         <p className="text-blue-100 text-sm leading-relaxed">
//           Set up your Digital Product Passport dashboard in minutes. Save time, stay compliant.
//         </p>
//       </div>

//       <div className="relative flex justify-center opacity-90">
//         <svg width="140" height="140" viewBox="0 0 140 140" fill="none">
//           <rect x="40" y="20" width="60" height="80" rx="8" fill="rgba(255,255,255,0.15)" />
//           <rect x="50" y="35" width="40" height="6" rx="3" fill="rgba(255,255,255,0.5)" />
//           <rect x="50" y="48" width="40" height="6" rx="3" fill="rgba(255,255,255,0.3)" />
//           <rect x="50" y="61" width="25" height="6" rx="3" fill="rgba(255,255,255,0.3)" />
//           <circle cx="70" cy="115" r="18" fill="rgba(255,255,255,0.12)" />
//           <path d="M62 115l6 6 12-12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
//         </svg>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    Left panel — white stepper (Steps 2-3)
// ══════════════════════════════════════════ */
// function StepperPanel({ currentStep }) {
//   return (
//     <div className="hidden lg:flex flex-col justify-between w-[300px] flex-shrink-0 bg-white px-8 py-12 border-r border-gray-100 relative">
//       <div>
//         <button
//           onClick={() => { window.location.href = "/"; }}
//           className="flex items-center gap-2 mb-14 focus:outline-none"
//         >
//           <img src={logo} alt="Provinyx" className="h-7 w-auto object-contain" />
//         </button>

//         <div className="space-y-7">
//           {STEPS.map((step) => {
//             const isDone   = step.id < currentStep;
//             const isActive = step.id === currentStep;
//             return (
//               <div key={step.id} className="flex items-center gap-3">
//                 <div style={{
//                   width: 26, height: 26, borderRadius: "50%", flexShrink: 0,
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                   fontSize: 12, fontWeight: 700,
//                   background: isDone ? "#22c55e" : "#fff",
//                   border: isDone ? "none" : isActive ? "2px solid #2563eb" : "2px solid #e2e8f0",
//                   color: isActive ? "#2563eb" : "#94a3b8",
//                   transition: "all 0.25s",
//                 }}>
//                   {isDone ? <Check size={14} color="#fff" /> : step.id}
//                 </div>
//                 <span style={{
//                   fontSize: 12.5, fontWeight: isActive ? 700 : 600,
//                   letterSpacing: "0.04em", textTransform: "uppercase",
//                   color: isDone ? "#94a3b8" : isActive ? "#2563eb" : "#cbd5e1",
//                 }}>
//                   {step.label}
//                 </span>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       <div className="flex justify-center opacity-80">
//         <svg width="110" height="110" viewBox="0 0 110 110" fill="none">
//           <rect x="15" y="40" width="35" height="55" rx="6" fill="#dbeafe" />
//           <rect x="55" y="25" width="35" height="70" rx="6" fill="#bfdbfe" />
//           <rect x="25" y="50" width="15" height="4" rx="2" fill="#93c5fd" />
//           <rect x="25" y="58" width="15" height="4" rx="2" fill="#93c5fd" />
//           <rect x="65" y="35" width="15" height="4" rx="2" fill="#60a5fa" />
//           <rect x="65" y="43" width="15" height="4" rx="2" fill="#60a5fa" />
//           <rect x="65" y="51" width="15" height="4" rx="2" fill="#60a5fa" />
//         </svg>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    Top-right help link
// ══════════════════════════════════════════ */
// function TopPrevious({ onClick }) {
//   return (
//     <div className="flex justify-start mb-6">
//       <button
//         onClick={onClick}
//         className="flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors"
//       >
//         <ArrowLeft size={16} /> Previous
//       </button>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    STEP 1 — Company Type
// ══════════════════════════════════════════ */
// function CompanyTypeStep({ value, onSelect, onNext, onPrevious }) {
//   return (
//     <div className="flex-1 px-6 sm:px-12 py-10 max-w-xl">
//       <TopPrevious onClick={onPrevious} />
//       <h1 className="text-2xl font-bold text-gray-900 mb-2">Choose the type of company</h1>
//       <p className="text-gray-500 text-sm mb-8">
//         Onboarding your company is just a few steps away. Select the option that best describes your business.
//       </p>

//       <div className="space-y-3">
//         {COMPANY_TYPES.map((type) => {
//           const Icon = type.icon;
//           const isSelected = value === type.id;
//           return (
//             <button
//               key={type.id}
//               onClick={() => { onSelect(type.id); setTimeout(onNext, 280); }}
//               className="w-full flex items-center gap-4 p-4 rounded-xl border text-left transition-all duration-200"
//               style={{
//                 borderColor: isSelected ? "#2563eb" : "#e5e7eb",
//                 background: isSelected ? "#eff6ff" : "#fff",
//                 boxShadow: isSelected ? "0 4px 16px rgba(37,99,235,0.12)" : "none",
//               }}
//             >
//               <div style={{
//                 width: 44, height: 44, borderRadius: 12, flexShrink: 0,
//                 background: isSelected ? "#2563eb" : "#f1f5f9",
//                 display: "flex", alignItems: "center", justifyContent: "center",
//                 transition: "background 0.2s",
//               }}>
//                 <Icon size={20} color={isSelected ? "#fff" : "#64748b"} />
//               </div>
//               <div className="flex-1">
//                 <p className="font-semibold text-gray-900 text-sm">{type.label}</p>
//                 <p className="text-gray-500 text-xs mt-0.5">{type.desc}</p>
//               </div>
//               <ArrowRight size={18} color={isSelected ? "#2563eb" : "#cbd5e1"} />
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    STEP 2 — Business Details (+ Company Mode)
// ══════════════════════════════════════════ */
// function BusinessDetailsStep({ data, onChange, onNext, onBack, domainVerified, onDomainVerifiedChange }) {
//   const [generating,   setGenerating]   = useState(false);
//   const [verifying,    setVerifying]    = useState(false);
//   const [tokenInfo,    setTokenInfo]    = useState(null);
//   const [domainError,  setDomainError]  = useState("");
//   const [existingCompany, setExistingCompany] = useState(null); // { dashboardUrl, companyName, status }
//   const [checkingExisting, setCheckingExisting] = useState(false);
//   const existingCheckRef = useRef(null);

//   const checkExistingCompany = async (website) => {
//     if (!website || website.trim().length < 4) { setExistingCompany(null); return; }
//     setCheckingExisting(true);
//     try {
//       const res = await fetch(`${API_BASE}/api/onboarding/check-existing-company?companyWebsite=${encodeURIComponent(website)}`);
//       const json = await res.json();
//       setExistingCompany(json.exists ? json : null);
//     } catch {
//       // silently ignore — this is a soft helpful check, not a hard requirement
//     } finally {
//       setCheckingExisting(false);
//     }
//   };

//   const handleWebsiteChange = (val) => {
//     onChange("companyWebsite", val);
//     if (domainVerified) onDomainVerifiedChange(false);
//     setTokenInfo(null);
//     setDomainError("");
//     setExistingCompany(null);

//     clearTimeout(existingCheckRef.current);
//     existingCheckRef.current = setTimeout(() => checkExistingCompany(val), 600);
//   };

//   useEffect(() => () => clearTimeout(existingCheckRef.current), []);

//   const handleGenerateToken = async () => {
//     if (!data.companyWebsite) return;
//     setGenerating(true);
//     setDomainError("");
//     try {
//       const res = await fetch(`${API_BASE}/api/onboarding/generate-domain-token`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ companyWebsite: data.companyWebsite }),
//       });
//       const json = await res.json();
//       if (json.error) setDomainError(json.error);
//       else setTokenInfo(json);
//     } catch {
//       setDomainError("Network error. Please try again.");
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const handleVerifyDomain = async () => {
//     setVerifying(true);
//     setDomainError("");
//     try {
//       const res = await fetch(`${API_BASE}/api/onboarding/verify-domain`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ companyWebsite: data.companyWebsite }),
//       });
//       const json = await res.json();
//       if (json.verified) {
//         onDomainVerifiedChange(true);
//         setTokenInfo(null);
//       } else {
//         setDomainError(json.reason || "Could not verify domain ownership.");
//       }
//     } catch {
//       setDomainError("Network error. Please try again.");
//     } finally {
//       setVerifying(false);
//     }
//   };

//   const isBlockingExisting = existingCompany && existingCompany.status === "ACTIVE";
//   const supplyChainRoleOk = data.companyMode !== "multiple" || !!data.supplyChainRole;
//   const valid = data.companyName && data.companyWebsite && data.country && data.companyMode && domainVerified && !isBlockingExisting && supplyChainRoleOk;

//   return (
//     <div className="flex-1 px-6 sm:px-12 py-10 flex flex-col max-w-xl">
//       <TopPrevious onClick={onBack} />
//       <h1 className="text-2xl font-bold text-gray-900 mb-2">About your company</h1>
//       <p className="text-gray-500 text-sm mb-8">Details about your company's name and online presence.</p>

//       <div className="space-y-5 flex-1">
//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Company name</label>
//           <input
//             type="text"
//             value={data.companyName}
//             onChange={(e) => onChange("companyName", e.target.value)}
//             placeholder="e.g. Acme Corporation"
//             className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
//           />
//         </div>

//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Company website</label>
//           <div className="flex flex-col sm:flex-row gap-2">
//             <div className="relative flex-1">
//               <Globe2 size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
//               <input
//                 type="text"
//                 value={data.companyWebsite}
//                 onChange={(e) => handleWebsiteChange(e.target.value)}
//                 disabled={domainVerified}
//                 placeholder="www.yourcompany.com"
//                 className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm disabled:bg-gray-50 disabled:text-gray-500"
//               />
//             </div>
//             <button
//               type="button"
//               onClick={handleGenerateToken}
//               disabled={!data.companyWebsite || domainVerified || generating}
//               className="flex-shrink-0 px-4 py-3 rounded-lg text-sm font-semibold transition-colors disabled:opacity-50 whitespace-nowrap"
//               style={{
//                 background: domainVerified ? "#dcfce7" : "#2563eb",
//                 color: domainVerified ? "#16a34a" : "#fff",
//               }}
//             >
//               {domainVerified ? "Verified" : generating ? <Loader2 size={16} className="animate-spin" /> : "Verify Ownership"}
//             </button>
//           </div>

//           {checkingExisting && (
//             <p className="text-xs text-gray-400 mt-1.5 flex items-center gap-1.5">
//               <Loader2 size={12} className="animate-spin" /> Checking if this company already has a workspace…
//             </p>
//           )}

//           {existingCompany && (
//             <div
//               className="mt-3 p-4 rounded-lg border"
//               style={{
//                 background: existingCompany.status === "ACTIVE" ? "#fef3c7" : "#f1f5f9",
//                 borderColor: existingCompany.status === "ACTIVE" ? "#fde68a" : "#e2e8f0",
//               }}
//             >
//               {existingCompany.status === "ACTIVE" ? (
//                 <>
//                   <p className="text-sm font-semibold text-amber-800 mb-1">
//                     You have already created a subdomain and workspace for this company
//                   </p>
//                   <p className="text-xs text-amber-700 mb-3">
//                     {existingCompany.companyName || "This company"} already has an active workspace. You can't create a second one for the same website.
//                   </p>
//                   <a
//                     href={existingCompany.dashboardUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber-900 underline"
//                   >
//                     Go to dashboard <ArrowRight size={14} />
//                   </a>
//                 </>
//               ) : (
//                 <p className="text-xs text-gray-500">
//                   A previous setup attempt for this website didn't finish successfully — you can continue and try again.
//                 </p>
//               )}
//             </div>
//           )}

//           {domainVerified && (
//             <p className="text-xs text-green-600 mt-1.5 flex items-center gap-1.5">
//               <CheckCircle2 size={13} /> Domain ownership verified — extra trust badge added
//             </p>
//           )}

//           {tokenInfo && !domainVerified && (
//             <div className="mt-3 p-4 rounded-lg bg-blue-50 border border-blue-100">
//               <p className="text-xs font-semibold text-gray-700 mb-2">Add this TXT record to your DNS settings:</p>
//               <div className="space-y-1.5 text-xs font-mono bg-white rounded-md p-2.5 border border-blue-100">
//                 <p><span className="text-gray-400">Host:</span> {tokenInfo.recordHost}</p>
//                 <p><span className="text-gray-400">Type:</span> TXT</p>
//                 <p className="break-all"><span className="text-gray-400">Value:</span> {tokenInfo.recordValue}</p>
//               </div>
//               <button
//                 type="button"
//                 onClick={handleVerifyDomain}
//                 disabled={verifying}
//                 className="mt-3 w-full bg-gray-900 text-white py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 flex items-center justify-center gap-1.5"
//               >
//                 {verifying ? (<><Loader2 size={14} className="animate-spin" /> Checking…</>) : "I've added it — Verify Now"}
//               </button>
//               <p className="text-xs text-gray-400 mt-2">DNS changes can take a few minutes to propagate. Tip: set the record's TTL to 300 seconds (5 min) or lower if your DNS provider allows it — this speeds up verification significantly. If you've tried before, edit your existing record's value instead of adding a new one — duplicate records cause verification to fail.</p>
//             </div>
//           )}

//           {domainError && (
//             <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1.5">
//               <AlertCircle size={12} /> {domainError}
//             </p>
//           )}

//           {!domainVerified && !tokenInfo && (
//             <p className="text-xs text-gray-400 mt-1.5">
//               Domain ownership verification is required to continue. Click "Verify Ownership" above for instructions.
//             </p>
//           )}
//         </div>

//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Country</label>
//           <select
//             value={data.country}
//             onChange={(e) => onChange("country", e.target.value)}
//             className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
//           >
//             <option value="">Select a country</option>
//             {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
//           </select>
//         </div>

//         {/* ── Company Mode — single vs multiple ── */}
//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-2 block">Company mode</label>
//           <div className="grid grid-cols-2 gap-3">
//             {COMPANY_MODES.map((mode) => {
//               const Icon = mode.icon;
//               const isSelected = data.companyMode === mode.id;
//               return (
//                 <button
//                   key={mode.id}
//                   type="button"
//                   onClick={() => onChange("companyMode", mode.id)}
//                   className="flex flex-col items-start gap-2 p-3.5 rounded-xl border text-left transition-all duration-200"
//                   style={{
//                     borderColor: isSelected ? "#2563eb" : "#e5e7eb",
//                     background: isSelected ? "#eff6ff" : "#fff",
//                   }}
//                 >
//                   <div style={{
//                     width: 34, height: 34, borderRadius: 9,
//                     background: isSelected ? "#2563eb" : "#f1f5f9",
//                     display: "flex", alignItems: "center", justifyContent: "center",
//                     transition: "background 0.2s",
//                   }}>
//                     <Icon size={16} color={isSelected ? "#fff" : "#64748b"} />
//                   </div>
//                   <div>
//                     <p className="font-semibold text-gray-900 text-xs">{mode.label}</p>
//                     <p className="text-gray-500 text-xs mt-0.5 leading-snug">{mode.desc}</p>
//                   </div>
//                 </button>
//               );
//             })}
//           </div>

//           {/* ── Supply chain role — only appears for Multiple Companies mode ── */}
//           {data.companyMode === "multiple" && (
//             <div className="mt-4">
//               <label className="text-sm font-medium text-gray-700 mb-1.5 block">Role</label>
//               <div className="relative">
//                 <Network size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
//                 <select
//                   value={data.supplyChainRole}
//                   onChange={(e) => onChange("supplyChainRole", e.target.value)}
//                   className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
//                 >
//                   <option value="">Select a role</option>
//                   {SUPPLY_CHAIN_ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
//                 </select>
//               </div>
//               <p className="text-xs text-gray-400 mt-1.5">This determines which workspace template your company's schema is provisioned from.</p>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="flex items-center justify-end mt-10 pt-6 border-t border-gray-100">
//         <button
//           onClick={onNext}
//           disabled={!valid}
//           className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2.5 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
//         >
//           Next <ArrowRight size={16} />
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    STEP 3 — Personal Details (+ User Role)
// ══════════════════════════════════════════ */
// function PersonalDetailsStep({ data, onChange, onSubmit, onBack, verifying, error, emailVerified, onEmailVerifiedChange }) {
//   const [sendingOtp,   setSendingOtp]   = useState(false);
//   const [otpSent,      setOtpSent]      = useState(false);
//   const [otpCode,      setOtpCode]      = useState("");
//   const [verifyingOtp, setVerifyingOtp] = useState(false);
//   const [otpError,     setOtpError]     = useState("");
//   const [cooldown,     setCooldown]     = useState(0);
//   const [showPw,       setShowPw]       = useState(false);
//   const [confirmPw,    setConfirmPw]    = useState("");
//   const [pwError,      setPwError]      = useState("");
//   const cooldownRef = useRef(null);

//   const websiteDomain = (data.companyWebsite || "")
//     .trim().toLowerCase().replace(/^https?:\/\//, "").replace(/^www\./, "").split("/")[0];

//   const handleEmailChange = (val) => {
//     onChange("companyEmail", val);
//     if (emailVerified) onEmailVerifiedChange(false);
//     setOtpSent(false);
//     setOtpCode("");
//     setOtpError("");
//   };

//   const startCooldown = (seconds) => {
//     setCooldown(seconds);
//     clearInterval(cooldownRef.current);
//     cooldownRef.current = setInterval(() => {
//       setCooldown((s) => {
//         if (s <= 1) { clearInterval(cooldownRef.current); return 0; }
//         return s - 1;
//       });
//     }, 1000);
//   };

//   useEffect(() => () => clearInterval(cooldownRef.current), []);

//   const handleSendOtp = async () => {
//     if (!data.companyEmail) return;

//     const emailDomain = (data.companyEmail.split("@")[1] || "").trim().toLowerCase();
//     if (websiteDomain && emailDomain !== websiteDomain) {
//       setOtpError(`Please use an email ending in @${websiteDomain} — it must match your company domain.`);
//       return;
//     }

//     setSendingOtp(true);
//     setOtpError("");
//     try {
//       const res = await fetch(`${API_BASE}/api/onboarding/send-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email: data.companyEmail }),
//       });
//       const json = await res.json();
//       if (!json.success) {
//         setOtpError(json.error || "Could not send verification code.");
//       } else {
//         setOtpSent(true);
//         startCooldown(30);
//       }
//     } catch {
//       setOtpError("Network error while sending the code. Please try again.");
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   const handleConfirmOtp = async () => {
//     if (otpCode.length !== 6) {
//       setOtpError("Please enter the 6-digit code.");
//       return;
//     }
//     setVerifyingOtp(true);
//     setOtpError("");
//     try {
//       const res = await fetch(`${API_BASE}/api/onboarding/verify-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email: data.companyEmail, otp: otpCode }),
//       });
//       const json = await res.json();
//       if (json.valid) {
//         onEmailVerifiedChange(true);
//         setOtpSent(false);
//       } else {
//         setOtpError(json.reason || "Incorrect code.");
//       }
//     } catch {
//       setOtpError("Network error while verifying the code. Please try again.");
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   const valid = data.fullName && data.companyEmail && data.role && emailVerified
//     && data.password && data.password.length >= 8 && confirmPw === data.password;

//   const handleSubmit = () => {
//     if (data.password.length < 8) {
//       setPwError("Password must be at least 8 characters.");
//       return;
//     }
//     if (data.password !== confirmPw) {
//       setPwError("Passwords do not match.");
//       return;
//     }
//     onSubmit();
//   };

//   return (
//     <div className="flex-1 px-6 sm:px-12 py-10 flex flex-col max-w-xl">
//       <TopPrevious onClick={onBack} />
//       <h1 className="text-2xl font-bold text-gray-900 mb-2">Personal details</h1>
//       <p className="text-gray-500 text-sm mb-8">Tell us who's setting up this account.</p>

//       <div className="space-y-5 flex-1">
//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Full name</label>
//           <div className="relative">
//             <User size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
//             <input
//               type="text"
//               value={data.fullName}
//               onChange={(e) => onChange("fullName", e.target.value)}
//               placeholder="John Doe"
//               className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
//             />
//           </div>
//         </div>

//         {/* ── User role ── */}
//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Your role</label>
//           <div className="relative">
//             <BriefcaseIcon size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
//             <select
//               value={data.roleCategory}
//               onChange={(e) => {
//                 const category = e.target.value;
//                 onChange("roleCategory", category);
//                 // For every option except "Other", the submitted role IS
//                 // the category. For "Other", the role stays empty until
//                 // the user actually types something in the text box below.
//                 onChange("role", category === "Other" ? "" : category);
//               }}
//               className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
//             >
//               <option value="">Select your role</option>
//               {USER_ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
//             </select>
//           </div>

//           {data.roleCategory === "Other" && (
//             <input
//               type="text"
//               value={data.role}
//               onChange={(e) => onChange("role", e.target.value)}
//               placeholder="Type your role"
//               autoFocus
//               className="w-full mt-2 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
//             />
//           )}
//         </div>

//         {/* ── Create password ── */}
//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Create a password</label>
//           <div className="relative">
//             <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
//             <input
//               type={showPw ? "text" : "password"}
//               value={data.password}
//               onChange={(e) => { onChange("password", e.target.value); setPwError(""); }}
//               placeholder="At least 8 characters"
//               className="w-full pl-10 pr-10 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
//             />
//             <button
//               type="button"
//               onClick={() => setShowPw((s) => !s)}
//               className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
//             >
//               {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
//             </button>
//           </div>
//         </div>

//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Confirm password</label>
//           <div className="relative">
//             <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
//             <input
//               type={showPw ? "text" : "password"}
//               value={confirmPw}
//               onChange={(e) => { setConfirmPw(e.target.value); setPwError(""); }}
//               placeholder="Re-enter your password"
//               className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
//             />
//           </div>
//           {pwError && (
//             <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1.5">
//               <AlertCircle size={12} /> {pwError}
//             </p>
//           )}
//         </div>

//         <div>
//           <label className="text-sm font-medium text-gray-700 mb-1.5 block">Company email</label>
//           <div className="flex flex-col sm:flex-row gap-2">
//             <div className="relative flex-1">
//               <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
//               <input
//                 type="email"
//                 value={data.companyEmail}
//                 onChange={(e) => handleEmailChange(e.target.value)}
//                 disabled={emailVerified}
//                 placeholder="you@yourcompany.com"
//                 className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm disabled:bg-gray-50 disabled:text-gray-500"
//               />
//             </div>
//             <button
//               type="button"
//               onClick={handleSendOtp}
//               disabled={!data.companyEmail || emailVerified || sendingOtp || cooldown > 0}
//               className="flex-shrink-0 px-4 py-3 rounded-lg text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
//               style={{
//                 background: emailVerified ? "#dcfce7" : "#2563eb",
//                 color: emailVerified ? "#16a34a" : "#fff",
//               }}
//             >
//               {emailVerified
//                 ? "Verified"
//                 : sendingOtp
//                   ? <Loader2 size={16} className="animate-spin" />
//                   : cooldown > 0
//                     ? `Resend (${cooldown}s)`
//                     : otpSent
//                       ? "Resend"
//                       : "Verify"}
//             </button>
//           </div>

//           {emailVerified && (
//             <p className="text-xs text-green-600 mt-1.5 flex items-center gap-1.5">
//               <CheckCircle2 size={13} /> Email has been verified
//             </p>
//           )}

//           {otpSent && !emailVerified && (
//             <div className="mt-3 flex gap-2 items-start">
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 maxLength={6}
//                 value={otpCode}
//                 onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ""))}
//                 placeholder="Enter 6-digit code"
//                 className="flex-1 px-4 py-2.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm tracking-widest"
//               />
//               <button
//                 type="button"
//                 onClick={handleConfirmOtp}
//                 disabled={verifyingOtp || otpCode.length !== 6}
//                 className="flex-shrink-0 bg-gray-900 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 flex items-center gap-1.5"
//               >
//                 {verifyingOtp ? <Loader2 size={14} className="animate-spin" /> : "Confirm"}
//               </button>
//             </div>
//           )}

//           {otpError && (
//             <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1.5">
//               <AlertCircle size={12} /> {otpError}
//             </p>
//           )}

//           {!emailVerified && (
//             <p className="text-xs text-gray-400 mt-1.5">Email verification is required to continue.</p>
//           )}
//         </div>

//         {error && (
//           <div className="flex items-start gap-2 p-3 rounded-lg bg-red-50 border border-red-100">
//             <AlertCircle size={16} className="text-red-500 flex-shrink-0 mt-0.5" />
//             <p className="text-red-600 text-xs leading-relaxed">{error}</p>
//           </div>
//         )}
//       </div>

//       <div className="flex items-center justify-end mt-10 pt-6 border-t border-gray-100">
//         <button
//           onClick={handleSubmit}
//           disabled={!valid || verifying}
//           className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2.5 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-60"
//         >
//           {verifying ? (<><Loader2 size={16} className="animate-spin" /> Verifying…</>) : (<>Verify & Continue <ArrowRight size={16} /></>)}
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    MODAL — Verified success → Create Subdomain trigger
// ══════════════════════════════════════════ */
// function VerifiedModal({ onCreateSubdomain, onClose }) {
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
//       <div className="bg-white rounded-2xl max-w-sm w-full p-8 text-center shadow-2xl" onClick={(e) => e.stopPropagation()}>
//         <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-5">
//           <CheckCircle2 size={34} className="text-green-500" />
//         </div>
//         <h3 className="text-xl font-bold text-gray-900 mb-2">You're Verified!</h3>
//         <p className="text-gray-500 text-sm leading-relaxed mb-7">
//           Your company details have been successfully verified. Let's set up your dashboard URL.
//         </p>
//         <button
//           onClick={onCreateSubdomain}
//           className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors"
//         >
//           Create Subdomain
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    MODAL — Create subdomain (reserves name + saves
//    company/user/subscription records — fast)
// ══════════════════════════════════════════ */
// function SubdomainModal({ data, onClose, onReserved }) {
//   const [subdomain, setSubdomain] = useState(
//     data.companyName.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 20)
//   );
//   const [checking,   setChecking]   = useState(false);
//   const [available,  setAvailable]  = useState(null);
//   const [reserving,  setReserving]  = useState(false);
//   const [error,      setError]      = useState("");
//   const debounceRef = useRef(null);

//   useEffect(() => {
//     clearTimeout(debounceRef.current);
//     setAvailable(null);
//     setError("");
//     const clean = subdomain.trim().toLowerCase();
//     if (clean.length < 3) return;

//     debounceRef.current = setTimeout(async () => {
//       setChecking(true);
//       try {
//         const res = await fetch(`${API_BASE}/api/onboarding/check-subdomain?subdomain=${encodeURIComponent(clean)}`);
//         const json = await res.json();
//         setAvailable(json.available);
//       } catch {
//         setError("Could not check availability. Please try again.");
//       } finally {
//         setChecking(false);
//       }
//     }, 450);

//     return () => clearTimeout(debounceRef.current);
//   }, [subdomain]);

//   const handleReserve = async () => {
//     if (!available) return;
//     setReserving(true);
//     setError("");
//     try {
//       const res = await fetch(`${API_BASE}/api/onboarding/create-subdomain`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           subdomain,
//           companyName: data.companyName,
//           companyWebsite: data.companyWebsite,
//           country: data.country,
//           companyType: data.companyType,
//           companyMode: data.companyMode,
//           supplyChainRole: data.supplyChainRole,
//           fullName: data.fullName,
//           companyEmail: data.companyEmail,
//           role: data.role,
//           password: data.password,
//         }),
//       });
//       const json = await res.json();
//       if (!json.success) {
//         setError(json.error || "Could not reserve subdomain. Please try again.");
//         setReserving(false);
//         return;
//       }
//       onReserved(subdomain);
//     } catch {
//       setError("Network error. Please try again.");
//       setReserving(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={reserving ? undefined : onClose}>
//       <div className="bg-white rounded-2xl max-w-md w-full p-7 shadow-2xl" onClick={(e) => e.stopPropagation()}>
//         <div className="flex items-center justify-between mb-1">
//           <h3 className="text-xl font-bold text-gray-900">Create your subdomain</h3>
//           {!reserving && (
//             <button onClick={onClose} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors">
//               <X size={16} className="text-gray-500" />
//             </button>
//           )}
//         </div>
//         <p className="text-gray-500 text-sm mb-6">This will be your unique DPP dashboard URL.</p>

//         <div className="flex items-stretch rounded-lg border border-gray-300 overflow-hidden focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500">
//           <input
//             type="text"
//             value={subdomain}
//             onChange={(e) => setSubdomain(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ""))}
//             placeholder="yourcompany"
//             className="flex-1 px-4 py-3 text-sm focus:outline-none"
//           />
//           <span className="flex items-center px-4 bg-gray-50 text-gray-500 text-sm font-medium border-l border-gray-300">
//             .provinyx.com
//           </span>
//         </div>

//         <div className="mt-3 min-h-[20px]">
//           {checking && <p className="text-xs text-gray-400 flex items-center gap-1.5"><Loader2 size={12} className="animate-spin" /> Checking availability…</p>}
//           {!checking && available === true  && <p className="text-xs text-green-600 flex items-center gap-1.5"><Check size={12} /> {subdomain}.provinyx.com is available</p>}
//           {!checking && available === false && <p className="text-xs text-red-500 flex items-center gap-1.5"><AlertCircle size={12} /> This subdomain is already taken</p>}
//           {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
//         </div>

//         <button
//           onClick={handleReserve}
//           disabled={!available || reserving}
//           className="w-full mt-5 bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
//         >
//           {reserving ? (<><Loader2 size={16} className="animate-spin" /> Reserving…</>) : "Create Subdomain"}
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    MODAL — Create Workspace (heavier provisioning,
//    shown with a multi-stage progress indicator)
// ══════════════════════════════════════════ */
// const WORKSPACE_STAGES = [
//   "Creating company workspace",
//   "Setting up your database",
//   "Linking your dashboard",
//   "Sending access email",
// ];

// function CreateWorkspaceModal({ subdomain, companyEmail, onClose, onComplete }) {
//   const [started,     setStarted]     = useState(false);
//   const [stageIndex,  setStageIndex]  = useState(0);
//   const [apiDone,     setApiDone]     = useState(false);
//   const [apiError,    setApiError]    = useState("");
//   const stageTimerRef = useRef(null);

//   const STAGE_DURATION = 900; // ms per cosmetic stage

//   const handleStart = () => {
//     setStarted(true);

//     // Advance the cosmetic stage indicator on a timer
//     stageTimerRef.current = setInterval(() => {
//       setStageIndex((i) => {
//         if (i >= WORKSPACE_STAGES.length - 1) {
//           clearInterval(stageTimerRef.current);
//           return i;
//         }
//         return i + 1;
//       });
//     }, STAGE_DURATION);

//     // Fire the real backend call in parallel
//     fetch(`${API_BASE}/api/onboarding/create-workspace`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ subdomain }),
//     })
//       .then((res) => res.json())
//       .then((json) => {
//         if (!json.success) {
//           setApiError(json.error || "Could not finish setting up your workspace.");
//         }
//         setApiDone(true);
//       })
//       .catch(() => {
//         setApiError("Network error while setting up your workspace.");
//         setApiDone(true);
//       });
//   };

//   useEffect(() => () => clearInterval(stageTimerRef.current), []);

//   // Once both the cosmetic animation AND the real API call have finished,
//   // move on to the final success (or error) state.
//   useEffect(() => {
//     const animationFinished = stageIndex >= WORKSPACE_STAGES.length - 1;
//     if (started && apiDone && animationFinished) {
//       clearInterval(stageTimerRef.current);
//       const t = setTimeout(() => {
//         if (apiError) {
//           // stay on this modal showing the error — handled in render below
//         } else {
//           onComplete();
//         }
//       }, 400);
//       return () => clearTimeout(t);
//     }
//   }, [started, apiDone, stageIndex, apiError, onComplete]);

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
//       <div className="bg-white rounded-2xl max-w-sm w-full p-8 text-center shadow-2xl">
//         {!started ? (
//           <>
//             <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-5">
//               <Building2 size={30} className="text-blue-600" />
//             </div>
//             <h3 className="text-xl font-bold text-gray-900 mb-2">Subdomain reserved!</h3>
//             <p className="text-gray-500 text-sm leading-relaxed mb-7">
//               <span className="font-semibold text-gray-700">{subdomain}.provinyx.com</span> is yours. Let's set up your live workspace.
//             </p>
//             <button
//               onClick={handleStart}
//               className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors"
//             >
//               Create Workspace
//             </button>
//           </>
//         ) : apiError ? (
//           <>
//             <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
//               <AlertCircle size={30} className="text-red-500" />
//             </div>
//             <h3 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h3>
//             <p className="text-gray-500 text-sm leading-relaxed mb-7">{apiError}</p>
//             <button
//               onClick={onClose}
//               className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-semibold text-sm hover:bg-gray-200 transition-colors"
//             >
//               Close
//             </button>
//           </>
//         ) : (
//           <>
//             <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-6">
//               <Loader2 size={30} className="text-blue-600 animate-spin" />
//             </div>
//             <h3 className="text-xl font-bold text-gray-900 mb-6">Setting up your workspace…</h3>
//             <div className="space-y-3 text-left">
//               {WORKSPACE_STAGES.map((stage, i) => {
//                 const isDone    = i < stageIndex;
//                 const isCurrent = i === stageIndex;
//                 return (
//                   <div key={stage} className="flex items-center gap-3">
//                     <div style={{
//                       width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
//                       display: "flex", alignItems: "center", justifyContent: "center",
//                       background: isDone ? "#22c55e" : isCurrent ? "#2563eb" : "#e5e7eb",
//                       transition: "background 0.3s",
//                     }}>
//                       {isDone ? <Check size={12} color="#fff" /> : isCurrent ? <Loader2 size={11} color="#fff" className="animate-spin" /> : null}
//                     </div>
//                     <span style={{ fontSize: 13, color: isDone || isCurrent ? "#374151" : "#9ca3af", fontWeight: isCurrent ? 600 : 400 }}>
//                       {stage}
//                     </span>
//                   </div>
//                 );
//               })}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    MODAL — Final success
// ══════════════════════════════════════════ */
// function SuccessModal({ companyEmail, onClose }) {
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
//       <div className="bg-white rounded-2xl max-w-sm w-full p-8 text-center shadow-2xl">
//         <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-5">
//           <Mail size={30} className="text-blue-600" />
//         </div>
//         <h3 className="text-xl font-bold text-gray-900 mb-2">Your workspace is ready!</h3>
//         <p className="text-gray-500 text-sm leading-relaxed mb-7">
//           We've sent your Provinyx access link to <span className="font-semibold text-gray-700">{companyEmail}</span>.
//         </p>
//         <button
//           onClick={onClose}
//           className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors"
//         >
//           Done
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════
//    MAIN FLOW
// ══════════════════════════════════════════ */
// export default function OnboardingFlow() {
//   const navigate = useNavigate();
//   const [step, setStep] = useState(1);
//   const [data, setData] = useState({
//     companyType: "", companyName: "", companyWebsite: "", country: "", companyMode: "", supplyChainRole: "",
//     fullName: "", companyEmail: "", role: "", roleCategory: "", password: "",
//   });

//   const [verifying, setVerifying] = useState(false);
//   const [verifyError, setVerifyError] = useState("");
//   const [domainVerified, setDomainVerified] = useState(false);
//   const [emailVerified, setEmailVerified] = useState(false);

//   const [showVerified,       setShowVerified]       = useState(false);
//   const [showSubdomain,      setShowSubdomain]      = useState(false);
//   const [showCreateWorkspace, setShowCreateWorkspace] = useState(false);
//   const [showSuccess,        setShowSuccess]        = useState(false);
//   const [reservedSubdomain,  setReservedSubdomain]  = useState("");

//   const update = (key, value) => setData((d) => ({ ...d, [key]: value }));

//   const handleVerify = () => {
//     setVerifying(true);
//     setVerifyError("");

//     const websiteDomain = data.companyWebsite
//       .trim().toLowerCase()
//       .replace(/^https?:\/\//, "").replace(/^www\./, "")
//       .split("/")[0];
//     const emailDomain = (data.companyEmail.split("@")[1] || "").trim().toLowerCase();

//     setTimeout(() => {
//       if (websiteDomain !== emailDomain) {
//         setVerifyError(
//           `Your verified email domain (${emailDomain}) doesn't match your verified website domain (${websiteDomain}). Please use an email on your company's domain.`
//         );
//         setVerifying(false);
//         return;
//       }
//       setVerifying(false);
//       setShowVerified(true);
//     }, 500);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Mobile-only header — BluePanel/StepperPanel (which hold the logo) are hidden below lg */}
//       <div className="flex lg:hidden items-center justify-between px-4 sm:px-6 py-4 bg-white border-b border-gray-100">
//         <button onClick={() => { window.location.href = "/"; }} className="flex items-center focus:outline-none">
//           <img src={logo} alt="Provinyx" className="h-7 w-auto object-contain" />
//         </button>
//         <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide">
//           Step {step} of 3
//         </span>
//       </div>

//       <div className="flex flex-col lg:flex-row min-h-screen">

//         {step === 1 ? <BluePanel /> : <StepperPanel currentStep={step} />}

//         {step === 1 && (
//           <CompanyTypeStep
//             value={data.companyType}
//             onSelect={(v) => update("companyType", v)}
//             onNext={() => setStep(2)}
//             onPrevious={() => navigate("/get-started")}
//           />
//         )}

//         {step === 2 && (
//           <BusinessDetailsStep
//             data={data}
//             onChange={update}
//             onNext={() => setStep(3)}
//             onBack={() => setStep(1)}
//             domainVerified={domainVerified}
//             onDomainVerifiedChange={setDomainVerified}
//           />
//         )}

//         {step === 3 && (
//           <PersonalDetailsStep
//             data={data}
//             onChange={update}
//             onSubmit={handleVerify}
//             onBack={() => setStep(2)}
//             verifying={verifying}
//             error={verifyError}
//             emailVerified={emailVerified}
//             onEmailVerifiedChange={setEmailVerified}
//           />
//         )}
//       </div>

//       {showVerified && (
//         <VerifiedModal
//           onClose={() => setShowVerified(false)}
//           onCreateSubdomain={() => { setShowVerified(false); setShowSubdomain(true); }}
//         />
//       )}

//       {showSubdomain && (
//         <SubdomainModal
//           data={data}
//           onClose={() => setShowSubdomain(false)}
//           onReserved={(subdomain) => {
//             setReservedSubdomain(subdomain);
//             setShowSubdomain(false);
//             setShowCreateWorkspace(true);
//           }}
//         />
//       )}

//       {showCreateWorkspace && (
//         <CreateWorkspaceModal
//           subdomain={reservedSubdomain}
//           companyEmail={data.companyEmail}
//           onClose={() => setShowCreateWorkspace(false)}
//           onComplete={() => { setShowCreateWorkspace(false); setShowSuccess(true); }}
//         />
//       )}

//       {showSuccess && (
//         <SuccessModal
//           companyEmail={data.companyEmail}
//           onClose={() => navigate("/")}
//         />
//       )}
//     </div>
//   );
// }




import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Building2, Rocket, Briefcase, Building, ArrowRight, ArrowLeft, Check, X,
  Loader2, Mail, Globe2, User, AlertCircle, CheckCircle2,
  Users, Layers, Briefcase as BriefcaseIcon, Lock, Eye, EyeOff, Network,
} from "lucide-react";
import logo from "../assets/Provinyx-logo.png";

// ── Backend API base URL — point this at your Node.js server ──────────────────
const API_BASE = "http://localhost:5000"; // ← local testing; switch back to your deployed URL later
// ─────────────────────────────────────────────────────────────────────────────

const COMPANY_TYPES = [
  { id: "small",   label: "Small Business", desc: "1 – 10 employees",        icon: Building2 },
  { id: "startup", label: "Startup",        desc: "Early-stage, high growth", icon: Rocket    },
  { id: "medium",  label: "Medium Business",desc: "11 – 200 employees",       icon: Briefcase },
  { id: "large",   label: "Large Enterprise",desc: "200+ employees",          icon: Building  },
];

const COMPANY_MODES = [
  { id: "single",   label: "Single Company",   desc: "One brand, one workspace",        icon: Building2 },
  { id: "multiple", label: "Multiple Companies", desc: "Manage several brands together", icon: Layers    },
];

// Exact 7 options required by the tech lead's multi-mode provisioning
// service (schemaProvisionServiceMulti.js TEMPLATE_MAP) — no "Other"
// option, since each one maps to a specific template schema on the
// backend and an unmapped value would throw "Unsupported company type".
const SUPPLY_CHAIN_ROLES = [
  "Manufacturer",
  "Distributor",
  "Retailer",
  "Recycler",
  "Regulator",
  "Customer",
  "Repair/Refurb",
];

const USER_ROLES = [
  "Owner / Founder",
  "Admin",
  "Operations Manager",
  "Compliance Officer",
  "IT / Technical Lead",
  "Other",
];

const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina",
  "Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados",
  "Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana",
  "Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon",
  "Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros",
  "Congo (Republic of)","Congo (DRC)","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic",
  "Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador",
  "Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Fiji","Finland","France",
  "Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea",
  "Guinea-Bissau","Guyana","Haiti","Honduras","Hungary","Iceland","India","Indonesia","Iran",
  "Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati",
  "Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein",
  "Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta",
  "Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco",
  "Mongolia","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal",
  "Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia",
  "Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru",
  "Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda",
  "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino",
  "Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone",
  "Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea",
  "South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria",
  "Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga",
  "Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine",
  "United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu",
  "Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe",
];

const STEPS = [
  { id: 1, label: "Company Type" },
  { id: 2, label: "Business Details" },
  { id: 3, label: "Personal Details" },
];

/* ══════════════════════════════════════════
   Left panel — blue intro (Step 1)
══════════════════════════════════════════ */
function BluePanel() {
  return (
    <div className="hidden lg:flex flex-col justify-between w-[380px] flex-shrink-0 px-10 py-12 text-white relative overflow-hidden"
      style={{ background: "linear-gradient(160deg,#2563eb 0%,#1e40af 100%)" }}>

      <div className="absolute top-0 right-0 w-72 h-72 bg-white/5 rounded-full translate-x-1/3 -translate-y-1/3 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-white/5 rounded-full -translate-x-1/3 translate-y-1/3 pointer-events-none" />

      <div className="relative">
        <button
          onClick={() => { window.location.href = "/"; }}
          className="flex items-center gap-2 mb-16 focus:outline-none"
        >
          <img src={logo} alt="Provinyx" className="h-7 w-auto object-contain" style={{ filter: "brightness(0) invert(1)" }} />
        </button>

        <h2 className="text-3xl font-bold leading-tight mb-4">
          A few clicks away from onboarding your company.
        </h2>
        <p className="text-blue-100 text-sm leading-relaxed">
          Set up your Digital Product Passport dashboard in minutes. Save time, stay compliant.
        </p>
      </div>

      <div className="relative flex justify-center opacity-90">
        <svg width="140" height="140" viewBox="0 0 140 140" fill="none">
          <rect x="40" y="20" width="60" height="80" rx="8" fill="rgba(255,255,255,0.15)" />
          <rect x="50" y="35" width="40" height="6" rx="3" fill="rgba(255,255,255,0.5)" />
          <rect x="50" y="48" width="40" height="6" rx="3" fill="rgba(255,255,255,0.3)" />
          <rect x="50" y="61" width="25" height="6" rx="3" fill="rgba(255,255,255,0.3)" />
          <circle cx="70" cy="115" r="18" fill="rgba(255,255,255,0.12)" />
          <path d="M62 115l6 6 12-12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   Left panel — white stepper (Steps 2-3)
══════════════════════════════════════════ */
function StepperPanel({ currentStep }) {
  return (
    <div className="hidden lg:flex flex-col justify-between w-[300px] flex-shrink-0 bg-white px-8 py-12 border-r border-gray-100 relative">
      <div>
        <button
          onClick={() => { window.location.href = "/"; }}
          className="flex items-center gap-2 mb-14 focus:outline-none"
        >
          <img src={logo} alt="Provinyx" className="h-7 w-auto object-contain" />
        </button>

        <div className="space-y-7">
          {STEPS.map((step) => {
            const isDone   = step.id < currentStep;
            const isActive = step.id === currentStep;
            return (
              <div key={step.id} className="flex items-center gap-3">
                <div style={{
                  width: 26, height: 26, borderRadius: "50%", flexShrink: 0,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 12, fontWeight: 700,
                  background: isDone ? "#22c55e" : "#fff",
                  border: isDone ? "none" : isActive ? "2px solid #2563eb" : "2px solid #e2e8f0",
                  color: isActive ? "#2563eb" : "#94a3b8",
                  transition: "all 0.25s",
                }}>
                  {isDone ? <Check size={14} color="#fff" /> : step.id}
                </div>
                <span style={{
                  fontSize: 12.5, fontWeight: isActive ? 700 : 600,
                  letterSpacing: "0.04em", textTransform: "uppercase",
                  color: isDone ? "#94a3b8" : isActive ? "#2563eb" : "#cbd5e1",
                }}>
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex justify-center opacity-80">
        <svg width="110" height="110" viewBox="0 0 110 110" fill="none">
          <rect x="15" y="40" width="35" height="55" rx="6" fill="#dbeafe" />
          <rect x="55" y="25" width="35" height="70" rx="6" fill="#bfdbfe" />
          <rect x="25" y="50" width="15" height="4" rx="2" fill="#93c5fd" />
          <rect x="25" y="58" width="15" height="4" rx="2" fill="#93c5fd" />
          <rect x="65" y="35" width="15" height="4" rx="2" fill="#60a5fa" />
          <rect x="65" y="43" width="15" height="4" rx="2" fill="#60a5fa" />
          <rect x="65" y="51" width="15" height="4" rx="2" fill="#60a5fa" />
        </svg>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   Top-right help link
══════════════════════════════════════════ */
function TopPrevious({ onClick }) {
  return (
    <div className="flex justify-start mb-6">
      <button
        onClick={onClick}
        className="flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors"
      >
        <ArrowLeft size={16} /> Previous
      </button>
    </div>
  );
}

/* ══════════════════════════════════════════
   STEP 1 — Company Type
══════════════════════════════════════════ */
function CompanyTypeStep({ value, onSelect, onNext, onPrevious }) {
  return (
    <div className="flex-1 px-6 sm:px-12 py-10 max-w-xl">
      <TopPrevious onClick={onPrevious} />
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Choose the type of company</h1>
      <p className="text-gray-500 text-sm mb-8">
        Onboarding your company is just a few steps away. Select the option that best describes your business.
      </p>

      <div className="space-y-3">
        {COMPANY_TYPES.map((type) => {
          const Icon = type.icon;
          const isSelected = value === type.id;
          return (
            <button
              key={type.id}
              onClick={() => { onSelect(type.id); setTimeout(onNext, 280); }}
              className="w-full flex items-center gap-4 p-4 rounded-xl border text-left transition-all duration-200"
              style={{
                borderColor: isSelected ? "#2563eb" : "#e5e7eb",
                background: isSelected ? "#eff6ff" : "#fff",
                boxShadow: isSelected ? "0 4px 16px rgba(37,99,235,0.12)" : "none",
              }}
            >
              <div style={{
                width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                background: isSelected ? "#2563eb" : "#f1f5f9",
                display: "flex", alignItems: "center", justifyContent: "center",
                transition: "background 0.2s",
              }}>
                <Icon size={20} color={isSelected ? "#fff" : "#64748b"} />
              </div>
              <div className="flex-1">
                <p className="font-semibold text-gray-900 text-sm">{type.label}</p>
                <p className="text-gray-500 text-xs mt-0.5">{type.desc}</p>
              </div>
              <ArrowRight size={18} color={isSelected ? "#2563eb" : "#cbd5e1"} />
            </button>
          );
        })}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   STEP 2 — Business Details (+ Company Mode)
══════════════════════════════════════════ */
function BusinessDetailsStep({ data, onChange, onNext, onBack }) {
  const [existingCompany, setExistingCompany] = useState(null);
  const [checkingExisting, setCheckingExisting] = useState(false);
  const existingCheckRef = useRef(null);

  // Auto-set companyMode to "single" — multiple mode is hidden for now
  useEffect(() => {
    if (!data.companyMode) onChange("companyMode", "single");
  }, []);

  const checkExistingCompany = async (website) => {
    if (!website || website.trim().length < 4) { setExistingCompany(null); return; }
    setCheckingExisting(true);
    try {
      const res = await fetch(`${API_BASE}/api/onboarding/check-existing-company?companyWebsite=${encodeURIComponent(website)}`);
      const json = await res.json();
      setExistingCompany(json.exists ? json : null);
    } catch {
      // silently ignore
    } finally {
      setCheckingExisting(false);
    }
  };

  const handleWebsiteChange = (val) => {
    onChange("companyWebsite", val);
    setExistingCompany(null);
    clearTimeout(existingCheckRef.current);
    existingCheckRef.current = setTimeout(() => checkExistingCompany(val), 600);
  };

  useEffect(() => () => clearTimeout(existingCheckRef.current), []);

  const isBlockingExisting = existingCompany && existingCompany.status === "ACTIVE";
  const valid = data.companyName && data.companyWebsite && data.country && !isBlockingExisting;

  return (
    <div className="flex-1 px-6 sm:px-12 py-10 flex flex-col max-w-xl">
      <TopPrevious onClick={onBack} />
      <h1 className="text-2xl font-bold text-gray-900 mb-2">About your company</h1>
      <p className="text-gray-500 text-sm mb-8">Details about your company's name and online presence.</p>

      <div className="space-y-5 flex-1">
        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Company name</label>
          <input
            type="text"
            value={data.companyName}
            onChange={(e) => onChange("companyName", e.target.value)}
            placeholder="e.g. Acme Corporation"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Company website</label>
          <div className="relative">
            <Globe2 size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={data.companyWebsite}
              onChange={(e) => handleWebsiteChange(e.target.value)}
              placeholder="www.yourcompany.com"
              className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            />
          </div>
          <p className="text-xs text-gray-400 mt-1.5">Your company email must match this domain (e.g. you@yourcompany.com).</p>

          {checkingExisting && (
            <p className="text-xs text-gray-400 mt-1.5 flex items-center gap-1.5">
              <Loader2 size={12} className="animate-spin" /> Checking if this company already has a workspace…
            </p>
          )}

          {existingCompany && (
            <div
              className="mt-3 p-4 rounded-lg border"
              style={{
                background: existingCompany.status === "ACTIVE" ? "#fef3c7" : "#f1f5f9",
                borderColor: existingCompany.status === "ACTIVE" ? "#fde68a" : "#e2e8f0",
              }}
            >
              {existingCompany.status === "ACTIVE" ? (
                <>
                  <p className="text-sm font-semibold text-amber-800 mb-1">
                    You have already created a subdomain and workspace for this company
                  </p>
                  <p className="text-xs text-amber-700 mb-3">
                    {existingCompany.companyName || "This company"} already has an active workspace. You can't create a second one for the same website.
                  </p>
                  <a
                    href={existingCompany.dashboardUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber-900 underline"
                  >
                    Go to dashboard <ArrowRight size={14} />
                  </a>
                </>
              ) : (
                <p className="text-xs text-gray-500">
                  A previous setup attempt for this website didn't finish successfully — you can continue and try again.
                </p>
              )}
            </div>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Country</label>
          <select
            value={data.country}
            onChange={(e) => onChange("country", e.target.value)}
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
          >
            <option value="">Select a country</option>
            {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        {/* Company mode is hardcoded to "single" — multiple mode is hidden until further notice */}
      </div>

      <div className="flex items-center justify-end mt-10 pt-6 border-t border-gray-100">
        <button
          onClick={onNext}
          disabled={!valid}
          className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2.5 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   STEP 3 — Personal Details (+ User Role)
══════════════════════════════════════════ */
function PersonalDetailsStep({ data, onChange, onSubmit, onBack, verifying, error, emailVerified, onEmailVerifiedChange }) {
  const [sendingOtp,   setSendingOtp]   = useState(false);
  const [otpSent,      setOtpSent]      = useState(false);
  const [otpCode,      setOtpCode]      = useState("");
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [otpError,     setOtpError]     = useState("");
  const [cooldown,     setCooldown]     = useState(0);
  const [showPw,       setShowPw]       = useState(false);
  const [confirmPw,    setConfirmPw]    = useState("");
  const [pwError,      setPwError]      = useState("");
  const cooldownRef = useRef(null);

  const websiteDomain = (data.companyWebsite || "")
    .trim().toLowerCase().replace(/^https?:\/\//, "").replace(/^www\./, "").split("/")[0];

  const handleEmailChange = (val) => {
    onChange("companyEmail", val);
    if (emailVerified) onEmailVerifiedChange(false);
    setOtpSent(false);
    setOtpCode("");
    setOtpError("");
  };

  const startCooldown = (seconds) => {
    setCooldown(seconds);
    clearInterval(cooldownRef.current);
    cooldownRef.current = setInterval(() => {
      setCooldown((s) => {
        if (s <= 1) { clearInterval(cooldownRef.current); return 0; }
        return s - 1;
      });
    }, 1000);
  };

  useEffect(() => () => clearInterval(cooldownRef.current), []);

  const handleSendOtp = async () => {
    if (!data.companyEmail) return;

    const emailDomain = (data.companyEmail.split("@")[1] || "").trim().toLowerCase();
    if (websiteDomain && emailDomain !== websiteDomain) {
      setOtpError(`Please use an email ending in @${websiteDomain} — it must match your company domain.`);
      return;
    }

    setSendingOtp(true);
    setOtpError("");
    try {
      const res = await fetch(`${API_BASE}/api/onboarding/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: data.companyEmail }),
      });
      const json = await res.json();
      if (!json.success) {
        setOtpError(json.error || "Could not send verification code.");
      } else {
        setOtpSent(true);
        startCooldown(30);
      }
    } catch {
      setOtpError("Network error while sending the code. Please try again.");
    } finally {
      setSendingOtp(false);
    }
  };

  const handleConfirmOtp = async () => {
    if (otpCode.length !== 6) {
      setOtpError("Please enter the 6-digit code.");
      return;
    }
    setVerifyingOtp(true);
    setOtpError("");
    try {
      const res = await fetch(`${API_BASE}/api/onboarding/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: data.companyEmail, otp: otpCode }),
      });
      const json = await res.json();
      if (json.valid) {
        onEmailVerifiedChange(true);
        setOtpSent(false);
      } else {
        setOtpError(json.reason || "Incorrect code.");
      }
    } catch {
      setOtpError("Network error while verifying the code. Please try again.");
    } finally {
      setVerifyingOtp(false);
    }
  };

  const valid = data.fullName && data.companyEmail && data.role && emailVerified
    && data.password && data.password.length >= 8;

  // Live password feedback — checked as the user types, not only on submit
  const passwordTooShort = data.password && data.password.length < 8;
  const passwordMismatch = confirmPw && data.password && confirmPw !== data.password;
  const passwordOk       = data.password && data.password.length >= 8 && confirmPw === data.password;

  const handleSubmit = () => {
    if (data.password.length < 8) {
      setPwError("Password must be at least 8 characters.");
      return;
    }
    if (data.password !== confirmPw) {
      setPwError("Passwords do not match.");
      return;
    }
    onSubmit();
  };

  return (
    <div className="flex-1 px-6 sm:px-12 py-10 flex flex-col max-w-xl">
      <TopPrevious onClick={onBack} />
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Personal details</h1>
      <p className="text-gray-500 text-sm mb-8">Tell us who's setting up this account.</p>

      <div className="space-y-5 flex-1">
        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Full name</label>
          <div className="relative">
            <User size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={data.fullName}
              onChange={(e) => onChange("fullName", e.target.value)}
              placeholder="John Doe"
              className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            />
          </div>
        </div>

        {/* ── User role ── */}
        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Your role</label>
          <div className="relative">
            <BriefcaseIcon size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
            <select
              value={data.roleCategory}
              onChange={(e) => {
                const category = e.target.value;
                onChange("roleCategory", category);
                // For every option except "Other", the submitted role IS
                // the category. For "Other", the role stays empty until
                // the user actually types something in the text box below.
                onChange("role", category === "Other" ? "" : category);
              }}
              className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white"
            >
              <option value="">Select your role</option>
              {USER_ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>

          {data.roleCategory === "Other" && (
            <input
              type="text"
              value={data.role}
              onChange={(e) => onChange("role", e.target.value)}
              placeholder="Type your role"
              autoFocus
              className="w-full mt-2 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            />
          )}
        </div>

        {/* ── Create password ── */}
        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Create a password</label>
          <div className="relative">
            <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type={showPw ? "text" : "password"}
              value={data.password}
              onChange={(e) => { onChange("password", e.target.value); setPwError(""); }}
              placeholder="Create a password"
              className={`w-full pl-10 pr-10 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition-colors ${
                passwordTooShort ? "border-red-400 focus:border-red-400 focus:ring-red-200"
                : data.password && !passwordTooShort ? "border-green-400 focus:border-green-400 focus:ring-green-200"
                : "border-gray-300 focus:border-blue-500"
              }`}
            />
            <button
              type="button"
              onClick={() => setShowPw((s) => !s)}
              className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          {/* Requirements always visible so user knows what's expected */}
          <div className="mt-2 space-y-1">
            <p className={`text-xs flex items-center gap-1.5 ${data.password && !passwordTooShort ? "text-green-600" : "text-gray-400"}`}>
              {data.password && !passwordTooShort ? <CheckCircle2 size={12} /> : <span className="w-3 h-3 rounded-full border border-gray-300 inline-block" />}
              At least 8 characters
            </p>
          </div>
          {passwordTooShort && (
            <p className="text-xs text-red-500 mt-1 flex items-center gap-1.5">
              <AlertCircle size={12} /> Too short — need at least 8 characters
            </p>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Confirm password</label>
          <div className="relative">
            <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type={showPw ? "text" : "password"}
              value={confirmPw}
              onChange={(e) => { setConfirmPw(e.target.value); setPwError(""); }}
              placeholder="Re-enter your password"
              className={`w-full pl-10 pr-4 py-3 rounded-lg border focus:outline-none focus:ring-2 text-sm transition-colors ${
                passwordMismatch ? "border-red-400 focus:border-red-400 focus:ring-red-200"
                : passwordOk ? "border-green-400 focus:border-green-400 focus:ring-green-200"
                : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              }`}
            />
          </div>
          {/* Live feedback — shown as they type, not only on submit */}
          {passwordMismatch && (
            <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1.5">
              <AlertCircle size={12} /> Passwords do not match
            </p>
          )}
          {passwordOk && (
            <p className="text-xs text-green-600 mt-1.5 flex items-center gap-1.5">
              <CheckCircle2 size={12} /> Passwords match
            </p>
          )}
          {pwError && !passwordMismatch && (
            <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1.5">
              <AlertCircle size={12} /> {pwError}
            </p>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-1.5 block">Company email</label>
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="relative flex-1">
              <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="email"
                value={data.companyEmail}
                onChange={(e) => handleEmailChange(e.target.value)}
                disabled={emailVerified}
                placeholder="you@yourcompany.com"
                className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm disabled:bg-gray-50 disabled:text-gray-500"
              />
            </div>
            <button
              type="button"
              onClick={handleSendOtp}
              disabled={!data.companyEmail || emailVerified || sendingOtp || cooldown > 0}
              className="flex-shrink-0 px-4 py-3 rounded-lg text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              style={{
                background: emailVerified ? "#dcfce7" : "#2563eb",
                color: emailVerified ? "#16a34a" : "#fff",
              }}
            >
              {emailVerified
                ? "Verified"
                : sendingOtp
                  ? <Loader2 size={16} className="animate-spin" />
                  : cooldown > 0
                    ? `Resend (${cooldown}s)`
                    : otpSent
                      ? "Resend"
                      : "Verify"}
            </button>
          </div>

          {emailVerified && (
            <p className="text-xs text-green-600 mt-1.5 flex items-center gap-1.5">
              <CheckCircle2 size={13} /> Email has been verified
            </p>
          )}

          {otpSent && !emailVerified && (
            <div className="mt-3 flex gap-2 items-start">
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ""))}
                placeholder="Enter 6-digit code"
                className="flex-1 px-4 py-2.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm tracking-widest"
              />
              <button
                type="button"
                onClick={handleConfirmOtp}
                disabled={verifyingOtp || otpCode.length !== 6}
                className="flex-shrink-0 bg-gray-900 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 flex items-center gap-1.5"
              >
                {verifyingOtp ? <Loader2 size={14} className="animate-spin" /> : "Confirm"}
              </button>
            </div>
          )}

          {otpError && (
            <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1.5">
              <AlertCircle size={12} /> {otpError}
            </p>
          )}

          {!emailVerified && (
            <p className="text-xs text-gray-400 mt-1.5">Email verification is required to continue.</p>
          )}
        </div>

        {error && (
          <div className="flex items-start gap-2 p-3 rounded-lg bg-red-50 border border-red-100">
            <AlertCircle size={16} className="text-red-500 flex-shrink-0 mt-0.5" />
            <p className="text-red-600 text-xs leading-relaxed">{error}</p>
          </div>
        )}
      </div>

      <div className="flex items-center justify-end mt-10 pt-6 border-t border-gray-100">
        <button
          onClick={handleSubmit}
          disabled={!valid || verifying}
          className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2.5 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-60"
        >
          {verifying ? (<><Loader2 size={16} className="animate-spin" /> Verifying…</>) : (<>Verify & Continue <ArrowRight size={16} /></>)}
        </button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   MODAL — Verified success → Create Subdomain trigger
══════════════════════════════════════════ */
function VerifiedModal({ onCreateSubdomain, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-sm w-full p-8 text-center shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-5">
          <CheckCircle2 size={34} className="text-green-500" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">You're Verified!</h3>
        <p className="text-gray-500 text-sm leading-relaxed mb-7">
          Your company details have been successfully verified. Let's set up your dashboard URL.
        </p>
        <button
          onClick={onCreateSubdomain}
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors"
        >
          Create Subdomain
        </button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   MODAL — Create subdomain (reserves name + saves
   company/user/subscription records — fast)
══════════════════════════════════════════ */
function SubdomainModal({ data, onClose, onReserved }) {
  const [subdomain, setSubdomain] = useState(
    data.companyName.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 20)
  );
  const [checking,   setChecking]   = useState(false);
  const [available,  setAvailable]  = useState(null);
  const [reserving,  setReserving]  = useState(false);
  const [error,      setError]      = useState("");
  const debounceRef = useRef(null);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    setAvailable(null);
    setError("");
    const clean = subdomain.trim().toLowerCase();
    if (clean.length < 3) return;

    debounceRef.current = setTimeout(async () => {
      setChecking(true);
      try {
        const res = await fetch(`${API_BASE}/api/onboarding/check-subdomain?subdomain=${encodeURIComponent(clean)}`);
        const json = await res.json();
        setAvailable(json.available);
      } catch {
        setError("Could not check availability. Please try again.");
      } finally {
        setChecking(false);
      }
    }, 450);

    return () => clearTimeout(debounceRef.current);
  }, [subdomain]);

  const handleReserve = async () => {
    if (!available) return;
    setReserving(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/api/onboarding/create-subdomain`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subdomain,
          companyName: data.companyName,
          companyWebsite: data.companyWebsite,
          country: data.country,
          companyType: data.companyType,
          companyMode: data.companyMode,
          supplyChainRole: data.supplyChainRole,
          fullName: data.fullName,
          companyEmail: data.companyEmail,
          role: data.role,
          password: data.password,
        }),
      });
      const json = await res.json();
      if (!json.success) {
        setError(json.error || "Could not reserve subdomain. Please try again.");
        setReserving(false);
        return;
      }
      onReserved(subdomain);
    } catch {
      setError("Network error. Please try again.");
      setReserving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={reserving ? undefined : onClose}>
      <div className="bg-white rounded-2xl max-w-md w-full p-7 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-xl font-bold text-gray-900">Create your subdomain</h3>
          {!reserving && (
            <button onClick={onClose} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors">
              <X size={16} className="text-gray-500" />
            </button>
          )}
        </div>
        <p className="text-gray-500 text-sm mb-6">This will be your unique DPP dashboard URL.</p>

        <div className="flex items-stretch rounded-lg border border-gray-300 overflow-hidden focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500">
          <input
            type="text"
            value={subdomain}
            onChange={(e) => setSubdomain(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ""))}
            placeholder="yourcompany"
            className="flex-1 px-4 py-3 text-sm focus:outline-none"
          />
          <span className="flex items-center px-4 bg-gray-50 text-gray-500 text-sm font-medium border-l border-gray-300">
            .provinyx.com
          </span>
        </div>

        <div className="mt-3 min-h-[20px]">
          {checking && <p className="text-xs text-gray-400 flex items-center gap-1.5"><Loader2 size={12} className="animate-spin" /> Checking availability…</p>}
          {!checking && available === true  && <p className="text-xs text-green-600 flex items-center gap-1.5"><Check size={12} /> {subdomain}.provinyx.com is available</p>}
          {!checking && available === false && <p className="text-xs text-red-500 flex items-center gap-1.5"><AlertCircle size={12} /> This subdomain is already taken</p>}
          {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>

        <button
          onClick={handleReserve}
          disabled={!available || reserving}
          className="w-full mt-5 bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {reserving ? (<><Loader2 size={16} className="animate-spin" /> Reserving…</>) : "Create Subdomain"}
        </button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   MODAL — Create Workspace (heavier provisioning,
   shown with a multi-stage progress indicator)
══════════════════════════════════════════ */
const WORKSPACE_STAGES = [
  "Creating company workspace",
  "Setting up your database",
  "Linking your dashboard",
  "Sending access email",
];

function CreateWorkspaceModal({ subdomain, companyEmail, onClose, onComplete }) {
  const [started,     setStarted]     = useState(false);
  const [stageIndex,  setStageIndex]  = useState(0);
  const [apiDone,     setApiDone]     = useState(false);
  const [apiError,    setApiError]    = useState("");
  const stageTimerRef = useRef(null);

  const STAGE_DURATION = 900; // ms per cosmetic stage

  const handleStart = () => {
    setStarted(true);

    // Advance the cosmetic stage indicator on a timer
    stageTimerRef.current = setInterval(() => {
      setStageIndex((i) => {
        if (i >= WORKSPACE_STAGES.length - 1) {
          clearInterval(stageTimerRef.current);
          return i;
        }
        return i + 1;
      });
    }, STAGE_DURATION);

    // Fire the real backend call in parallel
    fetch(`${API_BASE}/api/onboarding/create-workspace`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subdomain }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (!json.success) {
          setApiError(json.error || "Could not finish setting up your workspace.");
        }
        setApiDone(true);
      })
      .catch(() => {
        setApiError("Network error while setting up your workspace.");
        setApiDone(true);
      });
  };

  useEffect(() => () => clearInterval(stageTimerRef.current), []);

  // Once both the cosmetic animation AND the real API call have finished,
  // move on to the final success (or error) state.
  useEffect(() => {
    const animationFinished = stageIndex >= WORKSPACE_STAGES.length - 1;
    if (started && apiDone && animationFinished) {
      clearInterval(stageTimerRef.current);
      const t = setTimeout(() => {
        if (apiError) {
          // stay on this modal showing the error — handled in render below
        } else {
          onComplete();
        }
      }, 400);
      return () => clearTimeout(t);
    }
  }, [started, apiDone, stageIndex, apiError, onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl max-w-sm w-full p-8 text-center shadow-2xl">
        {!started ? (
          <>
            <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-5">
              <Building2 size={30} className="text-blue-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Subdomain reserved!</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-7">
              <span className="font-semibold text-gray-700">{subdomain}.provinyx.com</span> is yours. Let's set up your live workspace.
            </p>
            <button
              onClick={handleStart}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors"
            >
              Create Workspace
            </button>
          </>
        ) : apiError ? (
          <>
            <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
              <AlertCircle size={30} className="text-red-500" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-7">{apiError}</p>
            <button
              onClick={onClose}
              className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-semibold text-sm hover:bg-gray-200 transition-colors"
            >
              Close
            </button>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-6">
              <Loader2 size={30} className="text-blue-600 animate-spin" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-6">Setting up your workspace…</h3>
            <div className="space-y-3 text-left">
              {WORKSPACE_STAGES.map((stage, i) => {
                const isDone    = i < stageIndex;
                const isCurrent = i === stageIndex;
                return (
                  <div key={stage} className="flex items-center gap-3">
                    <div style={{
                      width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      background: isDone ? "#22c55e" : isCurrent ? "#2563eb" : "#e5e7eb",
                      transition: "background 0.3s",
                    }}>
                      {isDone ? <Check size={12} color="#fff" /> : isCurrent ? <Loader2 size={11} color="#fff" className="animate-spin" /> : null}
                    </div>
                    <span style={{ fontSize: 13, color: isDone || isCurrent ? "#374151" : "#9ca3af", fontWeight: isCurrent ? 600 : 400 }}>
                      {stage}
                    </span>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   MODAL — Final success
══════════════════════════════════════════ */
function SuccessModal({ companyEmail, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl max-w-sm w-full p-8 text-center shadow-2xl">
        <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-5">
          <Mail size={30} className="text-blue-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">Your workspace is ready!</h3>
        <p className="text-gray-500 text-sm leading-relaxed mb-7">
          We've sent your Provinyx access link to <span className="font-semibold text-gray-700">{companyEmail}</span>.
        </p>
        <button
          onClick={onClose}
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors"
        >
          Done
        </button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   MAIN FLOW
══════════════════════════════════════════ */
export default function OnboardingFlow() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    companyType: "", companyName: "", companyWebsite: "", country: "", companyMode: "", supplyChainRole: "",
    fullName: "", companyEmail: "", role: "", roleCategory: "", password: "",
  });

  const [verifying, setVerifying] = useState(false);
  const [verifyError, setVerifyError] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);

  const [showVerified,       setShowVerified]       = useState(false);
  const [showSubdomain,      setShowSubdomain]      = useState(false);
  const [showCreateWorkspace, setShowCreateWorkspace] = useState(false);
  const [showSuccess,        setShowSuccess]        = useState(false);
  const [reservedSubdomain,  setReservedSubdomain]  = useState("");

  const update = (key, value) => setData((d) => ({ ...d, [key]: value }));

  const handleVerify = () => {
    setVerifying(true);
    setVerifyError("");

    const websiteDomain = data.companyWebsite
      .trim().toLowerCase()
      .replace(/^https?:\/\//, "").replace(/^www\./, "")
      .split("/")[0];
    const emailDomain = (data.companyEmail.split("@")[1] || "").trim().toLowerCase();

    setTimeout(() => {
      if (websiteDomain !== emailDomain) {
        setVerifyError(
          `Your verified email domain (${emailDomain}) doesn't match your verified website domain (${websiteDomain}). Please use an email on your company's domain.`
        );
        setVerifying(false);
        return;
      }
      setVerifying(false);
      setShowVerified(true);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile-only header — BluePanel/StepperPanel (which hold the logo) are hidden below lg */}
      <div className="flex lg:hidden items-center justify-between px-4 sm:px-6 py-4 bg-white border-b border-gray-100">
        <button onClick={() => { window.location.href = "/"; }} className="flex items-center focus:outline-none">
          <img src={logo} alt="Provinyx" className="h-7 w-auto object-contain" />
        </button>
        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide">
          Step {step} of 3
        </span>
      </div>

      <div className="flex flex-col lg:flex-row min-h-screen">

        {step === 1 ? <BluePanel /> : <StepperPanel currentStep={step} />}

        {step === 1 && (
          <CompanyTypeStep
            value={data.companyType}
            onSelect={(v) => update("companyType", v)}
            onNext={() => setStep(2)}
            onPrevious={() => navigate("/get-started")}
          />
        )}

        {step === 2 && (
          <BusinessDetailsStep
            data={data}
            onChange={update}
            onNext={() => setStep(3)}
            onBack={() => setStep(1)}
          />
        )}

        {step === 3 && (
          <PersonalDetailsStep
            data={data}
            onChange={update}
            onSubmit={handleVerify}
            onBack={() => setStep(2)}
            verifying={verifying}
            error={verifyError}
            emailVerified={emailVerified}
            onEmailVerifiedChange={setEmailVerified}
          />
        )}
      </div>

      {showVerified && (
        <VerifiedModal
          onClose={() => setShowVerified(false)}
          onCreateSubdomain={() => { setShowVerified(false); setShowSubdomain(true); }}
        />
      )}

      {showSubdomain && (
        <SubdomainModal
          data={data}
          onClose={() => setShowSubdomain(false)}
          onReserved={(subdomain) => {
            setReservedSubdomain(subdomain);
            setShowSubdomain(false);
            setShowCreateWorkspace(true);
          }}
        />
      )}

      {showCreateWorkspace && (
        <CreateWorkspaceModal
          subdomain={reservedSubdomain}
          companyEmail={data.companyEmail}
          onClose={() => setShowCreateWorkspace(false)}
          onComplete={() => { setShowCreateWorkspace(false); setShowSuccess(true); }}
        />
      )}

      {showSuccess && (
        <SuccessModal
          companyEmail={data.companyEmail}
          onClose={() => navigate("/")}
        />
      )}
    </div>
  );
}